<template>
    <section class="px-4 py-10 md:py-16 bg-white">
        <div class="max-w-screen-xl mx-auto text-center">
            <h2 class="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 fade-in-up">How to Get Started</h2>

            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <!-- Step 1 -->
                <div
                    class="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition duration-300 transform hover:scale-105 fade-in-up delay-100">
                    <div class="flex justify-center mb-4">
                        <div
                            class="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-600 text-xl font-bold">
                            1
                        </div>
                    </div>
                    <h3 class="text-lg font-semibold text-gray-800 mb-2">Register Your Shop</h3>
                    <p class="text-gray-600 text-sm">
                        Sign up on our platform with basic details and get access to your dashboard.
                    </p>
                </div>

                <!-- Step 2 -->
                <div
                    class="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition duration-300 transform hover:scale-105 fade-in-up delay-200">
                    <div class="flex justify-center mb-4">
                        <div
                            class="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-600 text-xl font-bold">
                            2
                        </div>
                    </div>
                    <h3 class="text-lg font-semibold text-gray-800 mb-2">Upload KYC Documents</h3>
                    <p class="text-gray-600 text-sm">
                        Upload your shop registration, VAT certificate, and ID to get verified as a wholesaler or
                        retailer.
                    </p>
                </div>

                <!-- Step 3 -->
                <div
                    class="bg-gray-50 p-6 rounded-lg shadow hover:shadow-md transition duration-300 transform hover:scale-105 fade-in-up delay-300">
                    <div class="flex justify-center mb-4">
                        <div
                            class="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-600 text-xl font-bold">
                            3
                        </div>
                    </div>
                    <h3 class="text-lg font-semibold text-gray-800 mb-2">Browse and Order</h3>
                    <p class="text-gray-600 text-sm">
                        Explore categories, view wholesale prices, and place orders directly from the platform.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HowToSection',
};
</script>

<style scoped>
@keyframes fadeInUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-in-up {
    opacity: 0;
    animation: fadeInUp 0.8s ease forwards;
}

.delay-100 {
    animation-delay: 0.1s;
}

.delay-200 {
    animation-delay: 0.2s;
}

.delay-300 {
    animation-delay: 0.3s;
}
</style>
